// 「その他」のvalueを一元管理
export const OTHER_VALUES = {
  question4: "23",
  question5Sub: "32",
  question6Sub: "41",
  question7Sub: "50",
  question8Sub: "59",
  question9: "63",
};

// 「不満」「どちらかといえば不満」のvalueを一元管理
export const DISSATISFIED_VALUES = {
  question5: ["24", "25"], // 不満, どちらかといえば不満の順
  question6: ["33", "34"],
  question7: ["42", "43"],
  question8: ["51", "52"],
};
